import React, { useEffect, useRef, useState } from "react";
import { bigLogo } from "../../Assets";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userActivation } from "../../Redux/actions";
import Message from "../Components/Layout/Message";

const Loading = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { email, code } = useParams();
  useEffect(() => {
    dispatch(userActivation({ email, code }));
  }, []);

  return (
    <div className="loading-page">
      <Message />
      <figure>
        <img src={bigLogo} />
      </figure>
    </div>
  );
};
export default Loading;
